import type { IDynamicFormValidationParams } from './types';

export const defaultValidationParams: IDynamicFormValidationParams = {
  validateOnBlur: true,
};
